// extracted by mini-css-extract-plugin
export default {"component":"KCk0g"};